/**
 * 逻辑流编辑器 - 左侧节点面板（可拖拽添加节点）
 */

import React from 'react';
import {Draggable} from './DraggableNode';
import type {LogicFlowNodeType} from '../../../types/logicFlow';

interface NodePaletteItem {
    type: LogicFlowNodeType;
    label: string;
    description: string;
    color: string;
}

const PALETTE_ITEMS: NodePaletteItem[] = [
    {type: 'INDICATOR', label: '指标', description: '计算技术指标', color: '#8B5CF6'},
    {type: 'RULE', label: '规则', description: '条件与交易动作', color: '#F0B429'},
];

interface Props {
    onAddNode: (type: LogicFlowNodeType) => void;
}

const NodePalette: React.FC<Props> = ({onAddNode}) => {
    return (
        <div style={containerStyle}>
            <div style={titleStyle}>节点面板</div>
            <div style={subtitleStyle}>拖拽或点击添加节点</div>
            <div style={listStyle}>
                {PALETTE_ITEMS.map(item => (
                    <Draggable key={item.type} type={item.type} onAddNode={onAddNode}>
                        <div style={itemStyle(item.color)}>
                            <div style={dotStyle(item.color)}/>
                            <div>
                                <div style={itemLabelStyle}>{item.label}</div>
                                <div style={itemDescStyle}>{item.description}</div>
                            </div>
                        </div>
                    </Draggable>
                ))}
            </div>
        </div>
    );
};

// ========== 样式 ==========
const containerStyle: React.CSSProperties = {
    width: '200px',
    minWidth: '200px',
    padding: '16px 12px',
    borderRight: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(12,17,32,0.92)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    overflowY: 'auto',
};

const titleStyle: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 700,
    color: 'var(--pt-text-primary)',
};

const subtitleStyle: React.CSSProperties = {
    fontSize: '11px',
    color: 'var(--pt-text-secondary)',
    marginBottom: '4px',
};

const listStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
};

const itemStyle = (color: string): React.CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 12px',
    borderRadius: '10px',
    border: `1px solid ${color}33`,
    background: `${color}11`,
    cursor: 'grab',
    transition: 'all 0.2s',
});

const dotStyle = (color: string): React.CSSProperties => ({
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: color,
    flexShrink: 0,
});

const itemLabelStyle: React.CSSProperties = {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--pt-text-primary)',
};

const itemDescStyle: React.CSSProperties = {
    fontSize: '11px',
    color: 'var(--pt-text-secondary)',
    marginTop: '2px',
};

export default NodePalette;
